import type { FormConfig } from '@/utils/form';
import {
  anredeId,
  beruf,
  berufsstatus,
  bezugZumVnJuristischePerson,
  familienstand,
  fuehrerscheindatum,
  geburtsdatum,
  hasAnSicherheitstrainingTeilgenommen,
  hasFuehrerscheinInEUErworben,
  hasMinderjaehrigeKinder,
  hasMinderjaehrigeKinderAlterAeltestesKind,
  hasMinderjaehrigeKinderAlterJuengstesKind,
  hasPunkteInFlensburg,
  hasWohnsitzMin5JahreInBrd,
  isHauptnutzer,
  isMitarbeiterAutohersteller,
  isVorsteuerAbzugsberechtigt,
  minderjaehrigeKinderAlter,
  nationalitaet,
  speziellerArbeitgeber,
  tarifgruppe,
  vnIsFullAge,
} from '@/features/Sparten/shared/fieldConfigs/kfz/input/fahrerkreisFieldConfig';

export const fahrerkreisCompanyNutzerSection: FormConfig = {
  formName: 'KfzFahrerkreisCompanyNutzer',
  fieldConfigs: [
    bezugZumVnJuristischePerson,
    anredeId,
    geburtsdatum,
    familienstand,
    nationalitaet,
    berufsstatus,
    beruf,
    speziellerArbeitgeber,
    tarifgruppe,
    fuehrerscheindatum,
    vnIsFullAge,
    hasMinderjaehrigeKinder,
    minderjaehrigeKinderAlter,
    hasMinderjaehrigeKinderAlterJuengstesKind,
    hasMinderjaehrigeKinderAlterAeltestesKind,
    hasFuehrerscheinInEUErworben,
    hasAnSicherheitstrainingTeilgenommen,
    hasPunkteInFlensburg,
    isMitarbeiterAutohersteller,
    isVorsteuerAbzugsberechtigt,
    isHauptnutzer,
    hasWohnsitzMin5JahreInBrd,
  ],
};
